export default "<img ng-src=\"{{ vm.src }}\" height=\"{{ vm.height }}\" width=\"{{ vm.width }}\" alt=\"{{ vm.alt }}\" draggable=\"false\"> ";